import React from 'react'
import ServiceCoordinatorRegistration from '../../components/forms/serviceCoordinator/ServiceCoordinatorRegistration'

const ServiceCoordinatorPage = () => {
  return (
   <div className="container-fluid">
    <div className="row">
      <div class="col-xl-12 col-lg-12 col-md-12 col-12">
        <div class="card-layout">
         <ServiceCoordinatorRegistration />
        </div>
      </div>
    </div>
   </div>
  )
}

export default ServiceCoordinatorPage